var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(-210 -2627)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(210 2627)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_My_Location",
    d: "M19.182,1V4.743A16.263,16.263,0,0,0,4.743,19.182H1v3.636H4.743A16.263,16.263,0,0,0,19.182,37.257V41h3.636V37.257A16.263,16.263,0,0,0,37.257,22.818H41V19.182H37.257A16.263,16.263,0,0,0,22.818,4.743V1ZM21,8.273A12.727,12.727,0,1,1,8.273,21,12.649,12.649,0,0,1,21,8.273Zm0,7.273A5.455,5.455,0,1,0,26.455,21,5.455,5.455,0,0,0,21,15.545Z",
    transform: "translate(229 2646)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon10);
export default __webpack_public_path__ + "static/media/facilityIcon10.98b8e975d1d225b16e6c5d8159da90db.svg";
export { ForwardRef as ReactComponent };